import { useContext, useState, useRef, useEffect } from "react";
import { Alpha1Set, Area1Set, Color1Set, Ratio1Set, Ratio2Set } from "../App";

export const HanreiNormal = ({ metadata }) => {
  const { area1set } = useContext(Area1Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { color1set, setColor1Set } = useContext(Color1Set);

  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { ratio2set, setRatio2Set } = useContext(Ratio2Set);

  const [col1, setCol1Set] = useState(metadata.hanrei1_color);
  const [col2, setCol2Set] = useState(metadata.hanrei2_color);
  const [col3, setCol3Set] = useState(metadata.hanrei3_color || "");
  const [col4, setCol4Set] = useState(metadata.hanrei4_color || "");
  const [col5, setCol5Set] = useState(metadata.hanrei5_color || "");

  const animatedGroup1Ref = useRef(null);
  const animatedGroup2Ref = useRef(null);

  const setcol1 = (value) => {
    setCol1Set(value);
  };
  const setcol2 = (value) => {
    setCol2Set(value);
  };
  const setcol3 = (value) => {
    setCol3Set(value);
  };
  const setcol4 = (value) => {
    setCol4Set(value);
  };
  function pickerClicker1(e) {
    document.getElementById("bar1Picker").click();
  }
  function pickerClicker2(e) {
    document.getElementById("bar2Picker").click();
  }
  function pickerClicker3(e) {
    document.getElementById("bar3Picker").click();
  }
  function pickerClicker4(e) {
    document.getElementById("bar4Picker").click();
  }

  return (
    <>
      <div className="cursor-pointer pointer-events-auto">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 15 165 50"
          fontFamily='"Helvetica Neue",
              Arial,
              "Hiragino Kaku Gothic ProN",
              "Hiragino Sans",
              Meiryo,
              sans-serif;'
        >
          <g id="参考" display="none"></g>
          <g id="背景の白色">
            {/* <rect x="0" y="0" opacity="0.75" fill="#FFFFFF" width="165" height="85"/> */}
          </g>

          <g
            className="svg-bars animate-pulse animate-twice animate-duration-[2000ms] animate-ease-in-out animate-normal animate-fill-forwards"
            // className="svg-bars animate-fade-in-up"
            id="bar1"
            type="color"
            // onChange={e => document.getElementById("bar1Picker").click()}
            // onClick={pickerClicker1}
            pointerEvents="fill"
          >
            <polygon
              fill={col1}
              // className={`hover:fill-red-500`}
              // className={`fill-[${"#e51400"}] hover:fill-blue-500`}
              points="104.231,14.064 91.565,15.231 81.899,58.564 84.065,60.064 89.565,60.23 114.731,18.897"
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="114.565,19.231 100.899,19.397 91.732,15.564 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="84.399"
              y1="60.23"
              x2="100.899"
              y2="19.397"
            />
          </g>
          {/* <g id="オレンジ棒"> */}
          <g
            id="bar2"
            type="color"
            //  onClick={pickerClicker2}
            pointerEvents="fill"
            className="svg-bars animate-pulse animate-twice animate-duration-[2000ms] animate-ease-in-out animate-normal animate-fill-forwards"
          >
            <polygon
              fill={col2}
              // className={`hover:fill-orange-500`}
              // fill={metadata.hanrei2_color}
              points="89.065,31.731 84.233,27.731 73.733,28.064 73.565,60.064 76.899,61.896 82.065,60.896 	"
            />
            <path fill="none" d="M90.399,81.064" />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="88.774,31.897 78.565,32.73 73.815,28.314 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="76.733"
              y1="61.73"
              x2="78.565"
              y2="32.73"
            />
          </g>
          {/* <g id="黄色い棒"> */}
          {col3 && (
            <g
              id="bar3"
              type="color"
              //  onClick={pickerClicker3}
              pointerEvents="fill"
              className="svg-bars animate-pulse animate-twice animate-duration-[2000ms] animate-ease-in-out animate-normal animate-fill-forwards"
            >
              <polygon
                fill={col3}
                // className={`hover:fill-yellow-500`}
                // fill={metadata.hanrei3_color}
                points="74.399,46.397 70.399,41.064 61.399,42.73 63.899,59.23 67.233,62.064 72.899,60.396 "
              />
              <polyline
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                points="61.733,42.897 66.565,47.897 74.065,46.522 "
              />
              <line
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                x1="67.233"
                y1="62.064"
                x2="66.565"
                y2="47.897"
              />
            </g>
          )}
          {/* <g id="灰色の棒"> */}
          {col4 && (
            <g
              id="bar4"
              type="color"
              //  onClick={pickerClicker4}
              pointerEvents="fill"
              className="svg-bars animate-pulse animate-twice animate-duration-[2000ms] animate-ease-in-out animate-normal animate-fill-forwards"
            >
              <polygon
                fill={col4}
                // className={`hover:fill-gray-500`}
                // fill={metadata.hanrei4_color}
                points="63.903,51.641 59.919,48.961 53.521,51.97 58.485,62.356 61.505,63.524 65.415,61.22 "
              />
              <polyline
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                points="53.901,52.085 58.409,54.354 63.702,51.875 "
              />
              <line
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                x1="61.546"
                y1="63.512"
                x2="58.409"
                y2="54.354"
              />
            </g>
          )}
          {/* <g id="灰色の棒"> */}
          {col5 && (
            <g
              id="bar5"
              type="color"
              //  onClick={pickerClicker4}
              pointerEvents="fill"
              className="svg-bars animate-pulse animate-twice animate-duration-[2000ms] animate-ease-in-out animate-normal animate-fill-forwards"
            >
              <polygon
                fill={col5}
                // className={`hover:fill-gray-500`}
                // fill={metadata.hanrei4_color}
                points="55,55 50,54 45,57 50.485,64.356 54,65 58,62 "
              />
              <polyline
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                points="45,57 50,58 55,55 "
              />
              <line
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeMiterlimit="10"
                x1="54"
                y1="65"
                x2="50"
                y2="58"
              />
            </g>
          )}
          <g id="右の引き出し線と高さ凡例">
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="116.565"
              y1="19.189"
              x2="121.691"
              y2="19.189"
            />
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="119.316"
              y1="19.189"
              x2="119.316"
              y2="60.439"
            />
            <polygon points="121.566,23.564 116.94,23.439 119.316,18.939 " />
            <polygon points="117.065,55.939 121.691,56.064 119.316,60.564 " />
            <text transform="matrix(1 0 0 1 122.0239 30)" fontSize="5">
              高さ：
            </text>
            <text transform="matrix(1 0 0 1 123 40)" fontSize="5">
              {metadata.hanrei_height_name}
            </text>
            <text transform="matrix(1 0 0 1 123 48)" fontSize="5">
              {metadata.height_ratio}
            </text>
            <text transform="matrix(1 0 0 1 123 56)" fontSize="5">
              {metadata.hanrei_height_name_2}
            </text>
            <text transform="matrix(1 0 0 1 123 64)" fontSize="5">
              {metadata.hanrei_height_name_3}
            </text>
          </g>
          <g id="左上の引き出し線と色の凡例">
            <text transform="matrix(1 0 0 1 5 20.2715)" fontSize="5">
              色：{metadata.hanrei_color_name}{metadata.hanrei_color_name2}
            </text>
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeMiterlimit="10"
              x1="4.232"
              y1="22.731"
              x2="90.066"
              y2="22.731"
            />
            <circle cx="90" cy="22.897" r="1.083" />
          </g>
          <g id="左赤四角">
            <rect
              x="5"
              y="27.064"
              // onClick={pickerClicker1}
              fill={col1}
              width="5.5"
              height="5.333"
            />
            <text transform="matrix(1 0 0 1 13 31.2305)">
              <tspan x="0" y="0" fontSize="5">
                {metadata.hanrei1_name}
              </tspan>
            </text>
          </g>
          <g id="左オレンジ四角">
            <rect
              x="5"
              y="34.564"
              // onClick={pickerClicker2}
              fill={col2}
              // fill={metadata.hanrei2_color}
              width="5.5"
              height="5.333"
            />
            <text transform="matrix(1 0 0 1 13 38.7305)">
              <tspan x="0" y="0" fontSize="5">
                {metadata.hanrei2_name}
              </tspan>
            </text>
          </g>
          {col3 && (
            <g id="左黄色四角">
              <rect
                x="5"
                y="42.064"
                // onClick={pickerClicker3}
                fill={col3}
                // fill={metadata.hanrei3_color}
                width="5.5"
                height="5.333"
              />
              <text transform="matrix(1 0 0 1 13 46.2305)">
                <tspan x="0" y="0" fontSize="5">
                  {metadata.hanrei3_name}
                </tspan>
              </text>
            </g>
          )}
          {col4 && (
            <g id="左灰色四角">
              <rect
                x="5"
                y="49.564"
                // onClick={pickerClicker4}
                fill={col4}
                // fill={metadata.hanrei4_color}
                width="5.5"
                height="5.333"
              />
              <text transform="matrix(1 0 0 1 13 53.7305)">
                <tspan x="0" y="0" fontSize="5">
                  {metadata.hanrei4_name}
                </tspan>
              </text>
            </g>
          )}
          {col5 && (
            <g id="左５つ目四角">
              <rect
                x="5"
                y="57.064"
                // onClick={pickerClicker4}
                fill={col5}
                // fill={metadata.hanrei4_color}
                width="5.5"
                height="5.333"
              />
              <text transform="matrix(1 0 0 1 13 61.2305)">
                <tspan x="0" y="0" fontSize="5">
                  {metadata.hanrei5_name}
                </tspan>
              </text>
            </g>
          )}
        </svg>
      </div>

      <></>
    </>
  );
};
